import { render, staticRenderFns } from "./VUploadDocuments.vue?vue&type=template&id=4ae8df92&scoped=true&lang=pug"
import script from "./VUploadDocuments.vue?vue&type=script&lang=ts"
export * from "./VUploadDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8df92",
  null
  
)

export default component.exports